// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import { Dropdown, InputText } from 'ui_kit_qmd'
import './AccountSettingsEditMode.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { findIana } from 'windows-iana'
import { EditMemberImage } from './edit-member-image/EditMemberImage'
import AccountSettingsPageTitle from '../AccountSettingsPageTitle/AccountSettingsPageTitle'
import { PREFIX_DOCTOR_NAME_OPTIONS, SUFFIX_DOCTOR_NAME_OPTIONS, TIME_ZONE } from '../../../utils/constants'

import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { ErrorAlert } from '../../../components/ui_kit_quickMD/error-alert/erroralert'
import errorIcon from '../../../images/common/error-icon.svg'
import { setAdminProfile, setCurrentProfileImage } from '../../../store/accountSettings/AccountSettingsThunk'
import { setAdminError, setIsEditSuccess } from '../../../store/accountSettings/AccountSettingsActions'
import TimeZoneSelect from '../../../components/time-zone-select/timeZoneSelect'

const emailInputLabelStyle = {
  whiteSpace: 'nowrap',
  cursor: 'default',
}
const firstLastNameInputLabelStyle = {
  whiteSpace: 'nowrap',
  cursor: 'text',
}
const firstNameInputContainerStyle = {
  width: 427,
  marginLeft: 16,
}
const lastNameInputContainerStyle = {
  width: 427,
}
const emailInputContainerStyle = {
  width: '100%',
}

const prefixDropdownContainerStyle = {
  width: '160px',
}
const prefixDropdownListContainerStyle = {
  width: 158,
  marginTop: 8,
  maxHeight: 232,
  overflowY: 'hidden',
}
const suffixDropdownListContainerStyle = {
  width: 158,
  marginTop: 8,
  left: 16.5,
}

const suffixDropdownContainerStyle = {
  width: '160px',
  marginLeft: 16,
}

const errorToastWrapContainerStyle = {
  marginLeft: 'auto',
  marginRight: 'auto',
  top: 0,
  zIndex: 10,
  position: 'absolute',
  left: 0,
  right: 0,
}

const errorToastContainerStyle = {
  width: 550,
}

const timeZoneContainerStyle = {
  width: '100%',
  height: 60,
  display: 'flex',
  flexDirection: 'row',
  marginLeft: 0,
  marginTop: 44,
  paddingLeft: 0,
  position: 'relative',
}
const arrowStyle = {
  alignSelf: 'center',
  right: 16,
}
const selectedOptionStyle = {
  padding: 0,
  margin: '0px 0px 0px 16px',
  height: 28,
  width: '92%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  position: 'absolute',
  bottom: 4,
}
const dropDownContainerStyle = {
  marginTop: 8,
  height: 260,
  zIndex: 999999999,
}

const AccountSettingsEditMode = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    toggleIsEditMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsConfirmationPopUpOpened,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setSaveChangesFromPopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsChangedData,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    saveChangesFromPopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    newActiveTab,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setNewActiveTab,
  }) => {
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const profile = useSelector((state) => state.accountSettings.adminProfile)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const error = useSelector((state) => state.accountSettings.error)

    const initialProfileData = useRef(profile)

    const dispatch = useDispatch()
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    const navigate = useNavigate()

    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    const [email, setEmail] = useState(profile?.Email)
    const [firstName, setFirstName] = useState(profile?.FirstName)
    const [firstNameError, setFirstNameError] = useState(false)
    const [firstNameLocalError, setFirstNameLocalError] = useState('')
    const [prefix, setPrefix] = useState(profile?.Prefix ? profile.Prefix : null)
    const [lastName, setLastName] = useState(profile?.LastName)
    const [lastNameError, setLastNameError] = useState(false)
    const [lastNameLocalError, setLastNameLocalError] = useState('')
    const [profileImgInputValue, setProfileImgInputValue] = useState(null)
    const [suffix, setSuffix] = useState(profile?.Suffix ? profile.Suffix : null)
    const [isImageChanged, setIsImageChanged] = useState(false)
    const [customTimeZone, setCustomTimeZone] = useState(profile.TimeZone ? findIana(profile.TimeZone)[0] : undefined)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const isProfileInfoEditSuccess = useSelector((state) => state.accountSettings.isProfileInfoEditSuccess)

    const checkIfProfileDataChanged = useCallback(() => {
      const { FirstName, LastName, Prefix, Suffix, TimeZone } = initialProfileData.current
      const initialTimeZone = findIana(TimeZone)[0]

      const correctSuffix = Suffix === null ? null : Suffix
      const correctPrefix = Prefix === null ? null : Prefix

      const currentPrefix = prefix === ' ' ? null : prefix
      const currentSuffix = suffix === ' ' ? null : suffix

      return (
        FirstName !== firstName ||
        LastName !== lastName ||
        correctPrefix !== currentPrefix ||
        correctSuffix !== currentSuffix ||
        isImageChanged ||
        initialTimeZone !== customTimeZone
      )
    }, [firstName, lastName, prefix, suffix, customTimeZone, isImageChanged])

    const onSafeEditedProvider = useCallback(() => {
      if (!checkIfProfileDataChanged()) {
        setIsChangedData(false)
        toggleIsEditMode(false)
        return
      }
      setIsChangedData(true)
      if (firstName?.trim() === '' || lastName?.trim() === '') {
        if (firstName?.trim() === '') {
          setFirstNameLocalError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'First name'))
          setFirstNameError(true)
        }
        if (lastName?.trim() === '') {
          setLastNameLocalError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Last name'))
          setLastNameError(true)
        }
        dispatch(setAdminError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)))
      } else {
        const newAdminProfileData = {
          FirstName: firstName,
          LastName: lastName,
          Prefix: prefix,
          Suffix: suffix,
          TimeZone: customTimeZone,
        }
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(setAdminProfile(newAdminProfileData))
      }
    }, [
      checkIfProfileDataChanged,
      setIsChangedData,
      firstName,
      lastName,
      toggleIsEditMode,
      dispatch,
      prefix,
      suffix,
      customTimeZone,
    ])

    const onSafeBtnInPopUpClicked = useCallback(() => {
      if (!firstName.trim().length || !lastName.trim().length) {
        onSafeEditedProvider()
        setIsConfirmationPopUpOpened(false)
      } else {
        onSafeEditedProvider()
        if (!newActiveTab.redirect) {
          setIsConfirmationPopUpOpened(false)
          toggleIsEditMode(false)
          setSaveChangesFromPopUp(false)
          setIsChangedData(false)
        }
      }
    }, [
      firstName,
      lastName,
      newActiveTab.redirect,
      onSafeEditedProvider,
      setIsChangedData,
      setIsConfirmationPopUpOpened,
      setSaveChangesFromPopUp,
      toggleIsEditMode,
    ])

    useEffect(() => {
      if (saveChangesFromPopUp) {
        onSafeBtnInPopUpClicked()
      }
    }, [onSafeBtnInPopUpClicked, saveChangesFromPopUp])

    useEffect(() => {
      setProfileImgInputValue(profile?.ImageUrl)
    }, [profile?.ImageUrl])

    useEffect(() => {
      if (isProfileInfoEditSuccess) {
        if (isImageChanged && profileImgInputValue !== '') {
          const fr = new FileReader()
          // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
          if (document.getElementById('profileImg').files[0]) {
            // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
            fr.readAsDataURL(document.getElementById('profileImg').files[0])
          }
          const formData = new FormData()
          // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
          formData.append('Image', profileImgInputValue)
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(setCurrentProfileImage(formData))
        } else {
          dispatch(setIsEditSuccess(true))
        }
      }
    }, [isProfileInfoEditSuccess])

    useEffect(() => {
      if (error) {
        setTimeout(() => {
          dispatch(setAdminError(''))
        }, 3500)
      }
    }, [error])

    const onSetFormValues = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (type) => (value) => {
        switch (type) {
          case 'firstName': {
            if (value.length < 51) {
              setFirstNameLocalError('')
              setFirstNameError(false)
              setFirstName(value)
            }
            break
          }
          case 'lastName': {
            if (value.length < 51) {
              setLastNameLocalError('')
              setLastNameError(false)
              setLastName(value)
            }
            break
          }
          default:
            break
        }
      },
      [],
    )

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetCurrentDateTimeZone = useCallback((value) => {
      setCustomTimeZone(value?.value)
    }, [])

    const onCancelBtnClicked = useCallback(() => {
      if (checkIfProfileDataChanged()) {
        setIsConfirmationPopUpOpened(true)
      } else {
        toggleIsEditMode(false)
      }
    }, [checkIfProfileDataChanged, setIsConfirmationPopUpOpened, toggleIsEditMode])

    const onSafeBtnHandler = useCallback(() => {
      setIsChangedData(false)
      onSafeEditedProvider()
    }, [onSafeEditedProvider, setIsChangedData])

    return (
      <>
        {error === getUserFriendlyErrorMessage(errorCodes.DEFAULT) && (
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          <div style={errorToastWrapContainerStyle}>
            <ErrorAlert
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              styleContainer={errorToastContainerStyle}
              errorText={error}
              errorImg={errorIcon}
              imgAlt='Error'
            />
          </div>
        )}
        <AccountSettingsPageTitle
          onSafeBtnClicked={onSafeBtnHandler}
          isEditMode
          onCancelBtnClicked={onCancelBtnClicked}
        />
        <div className='edit-settings-container-wrapper'>
          <div>
            <EditMemberImage
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              isVisible
              setPageStatus={() => {}}
              profileImgInputValue={profileImgInputValue}
              isImageChanged={isImageChanged}
              setProfileImgInputValue={setProfileImgInputValue}
              setIsImageChanged={setIsImageChanged}
            />
          </div>
          <div className='admin-edit-container'>
            <InputText
              labelStyle={emailInputLabelStyle}
              containerStyle={emailInputContainerStyle}
              label='Email*'
              view='visitType'
              setValue={() => {}}
              isError={false}
              localError={false}
              value={email}
              disabled
              id='EmailFieldEditMember'
            />
            <div className='admin-inputs-row'>
              <Dropdown
                options={PREFIX_DOCTOR_NAME_OPTIONS}
                containerStyle={prefixDropdownContainerStyle}
                dropdownContainerStyle={prefixDropdownListContainerStyle}
                value={prefix}
                setValue={setPrefix}
                dropId='Prefix'
                label='Prefix'
              />
              <InputText
                labelStyle={firstLastNameInputLabelStyle}
                containerStyle={firstNameInputContainerStyle}
                label='First name*'
                view='visitType'
                setValue={onSetFormValues('firstName')}
                isError={firstNameError}
                localError={firstNameLocalError}
                value={firstName}
                id='FirstNameFieldEditMember'
              />
            </div>
            <div className='admin-inputs-row'>
              <InputText
                labelStyle={firstLastNameInputLabelStyle}
                containerStyle={lastNameInputContainerStyle}
                label='Last name*'
                view='visitType'
                setValue={onSetFormValues('lastName')}
                isError={lastNameError}
                localError={lastNameLocalError}
                value={lastName}
                id='LastNameFieldEditMember'
              />
              <Dropdown
                options={SUFFIX_DOCTOR_NAME_OPTIONS}
                value={suffix}
                setValue={setSuffix}
                containerStyle={suffixDropdownContainerStyle}
                dropdownContainerStyle={suffixDropdownListContainerStyle}
                dropId='Suffix'
                label='Suffix'
              />
            </div>
            <TimeZoneSelect
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              onSetCurrentDateTimeZone={onSetCurrentDateTimeZone}
              customSelectedTimezone={customTimeZone}
              containerStyle={timeZoneContainerStyle}
              arrowStyle={arrowStyle}
              selectedOptionStyle={selectedOptionStyle}
              label={TIME_ZONE}
              dropDownContainerStyle={dropDownContainerStyle}
              useDefault
            />
          </div>
        </div>
      </>
    )
  },
)

export default AccountSettingsEditMode
